export const M1_UNIT_14 = {
  id: "u14-describing-week",
  title: "Unidad 14: My Week",
  topic: "Days, Prepositions & Weekly Routines",
  iconType: "calendar",
  grammarImage: "/u14-days-week.jpg",
  grammarText: "Uso de 'ON' para días (On Monday) y 'AT' para el fin de semana (At the weekend - UK) o 'ON' (US).",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: DAYS & PREPOSITIONS (Basic Logic)
    // Enfoque: Orden y preposiciones correctas.
    // ----------------------------------------------------------------------
    {
      id: "u14-set1",
      title: "Set 1: Days of the Week",
      questions: [
        {
          type: "match",
          q: "Order the days",
          pairs: [
            { left: "1. Monday", right: "Start of week" },
            { left: "5. Friday", right: "End of work week" },
            { left: "7. Sunday", right: "Rest day" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I play soccer ___ Monday.", options: ["on", "in", "at"], a: "on" },
        { type: "mc", q: "The party is ___ Friday night.", options: ["on", "in", "at"], a: "on" },
        { type: "input", q: "See you ___ (el) Tuesday!", a: "on" },
        { type: "match",
          q: "Match Preposition",
          pairs: [
            { left: "ON", right: "Wednesday" },
            { left: "IN", right: "The morning" },
            { left: "AT", right: "Night" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["I", "work", "on", "Saturdays."], a: "I work on Saturdays." },
        { type: "input", q: "We relax ___ (el) Sunday.", a: "on" },
        { type: "mc", q: "What do you do ___ the weekend?", options: ["on", "in", "to"], a: "on" },
        { type: "order", q: "Ordena", words: ["Do", "you", "work", "on", "Friday?"], a: "Do you work on Friday?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: WEEKDAYS vs WEEKEND (Conceptos)
    // Enfoque: Entender la estructura de la semana.
    // ----------------------------------------------------------------------
    {
      id: "u14-set2",
      title: "Set 2: Weekdays & Weekend",
      questions: [
        {
          type: "match",
          q: "Categorize",
          pairs: [
            { left: "Monday to Friday", right: "Weekdays" },
            { left: "Saturday & Sunday", right: "Weekend" },
            { left: "Wednesday", right: "Midweek" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I work from Monday ___ Friday.", options: ["to", "until", "at"], a: "to" },
        { type: "mc", q: "Schools are closed on the ___.", options: ["weekend", "weekdays", "Monday"], a: "weekend" },
        { type: "input", q: "I love the ___ (fin de semana)!", a: "weekend" },
        { type: "order", q: "Ordena", words: ["I", "hate", "Mondays."], a: "I hate Mondays." },
        { type: "match",
          q: "Activity Match",
          pairs: [
            { left: "Go to work", right: "Weekdays" },
            { left: "Sleep late", right: "Weekend" },
            { left: "Go to church", right: "Sunday" }
          ],
          a: "completed"
        },
        { type: "input", q: "Monday is the ___ (first) day of the week.", a: "first" },
        { type: "order", q: "Ordena", words: ["See", "you", "next", "week."], a: "See you next week." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: LOGICAL MATCHING (Action + Context)
    // Enfoque: Colocaciones (Go shopping, Play tennis).
    // ----------------------------------------------------------------------
    {
      id: "u14-set3",
      title: "Set 3: Activities Logic",
      questions: [
        {
          type: "match",
          q: "Match Verb to Noun",
          pairs: [
            { left: "Play", right: "Tennis" },
            { left: "Go", right: "Shopping" },
            { left: "Watch", right: "TV" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ swimming on Tuesdays.", options: ["go", "play", "do"], a: "go" },
        { type: "mc", q: "He ___ the guitar on Fridays.", options: ["plays", "goes", "does"], a: "plays" },
        { type: "input", q: "We ___ (ir) to the cinema on Saturday.", a: "go" },
        { type: "match",
          q: "Match Verb to Place",
          pairs: [
            { left: "Work", right: "In an office" },
            { left: "Study", right: "At school" },
            { left: "Relax", right: "At home" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["I", "play", "football", "on", "Sunday."], a: "I play football on Sunday." },
        { type: "input", q: "She ___ (jugar) video games.", a: "plays" },
        { type: "order", q: "Ordena", words: ["Let's", "go", "shopping."], a: "Let's go shopping." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: TRANSLATION CHALLENGE 1 (Simple)
    // Enfoque: Traducir frases cortas de rutina.
    // ----------------------------------------------------------------------
    {
      id: "u14-set4",
      title: "Set 4: Translate Basic Routines",
      questions: [
        { type: "order", q: "Traduce: 'Yo trabajo los lunes.'", words: ["I", "work", "on", "Mondays."], a: "I work on Mondays." },
        { type: "order", q: "Traduce: 'Ella estudia los viernes.'", words: ["She", "studies", "on", "Fridays."], a: "She studies on Fridays." },
        { type: "order", q: "Traduce: 'Nosotros vamos al parque.'", words: ["We", "go", "to", "the", "park."], a: "We go to the park." },
        { type: "match",
          q: "Translate the verb",
          pairs: [
            { left: "I work", right: "Yo trabajo" },
            { left: "I rest", right: "Yo descanso" },
            { left: "I clean", right: "Yo limpio" }
          ],
          a: "completed"
        },
        { type: "input", q: "Traduce: 'My brother plays soccer.' (Mi hermano ___ fútbol).", a: "juega" },
        { type: "mc", q: "Traduce: 'Ellos cocinan los domingos.'", options: ["They cook on Sundays.", "They cooking Sundays.", "They cooks on Sundays."], a: "They cook on Sundays." },
        { type: "order", q: "Traduce: 'Yo duermo mucho.'", words: ["I", "sleep", "a", "lot."], a: "I sleep a lot." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: TRANSLATION CHALLENGE 2 (Complex)
    // Enfoque: Traducir frases con frecuencia y tiempo.
    // ----------------------------------------------------------------------
    {
      id: "u14-set5",
      title: "Set 5: Translate Full Sentences",
      questions: [
        { type: "order", q: "Traduce: 'Yo trabajo por las mañanas.'", words: ["I", "work", "in", "the", "mornings."], a: "I work in the mornings." },
        { type: "order", q: "Traduce: 'Él va a la escuela de lunes a viernes.'", words: ["He", "goes", "to", "school", "from", "Monday", "to", "Friday."], a: "He goes to school from Monday to Friday." },
        { type: "match",
          q: "Time Expressions",
          pairs: [
            { left: "Every day", right: "Todos los días" },
            { left: "Once a week", right: "Una vez a la semana" },
            { left: "On weekends", right: "Los fines de semana" }
          ],
          a: "completed"
        },
        { type: "input", q: "Traduce: 'She never works on Sunday.' (Ella ___ trabaja los domingos).", a: "nunca" },
        { type: "order", q: "Traduce: 'Nosotros siempre comemos pizza los viernes.'", words: ["We", "always", "eat", "pizza", "on", "Fridays."], a: "We always eat pizza on Fridays." },
        { type: "mc", q: "Traduce: '¿Trabajas hoy?'", options: ["Do you work today?", "Work you today?", "Are you work today?"], a: "Do you work today?" },
        { type: "order", q: "Traduce: 'Mis amigos juegan tenis.'", words: ["My", "friends", "play", "tennis."], a: "My friends play tennis." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: LOGIC PUZZLE (Reading)
    // Enfoque: Deducir información de un horario.
    // ----------------------------------------------------------------------
    {
      id: "u14-set6",
      title: "Set 6: Sarah's Schedule",
      questions: [
        {
          type: "match",
          q: "Sarah's Calendar",
          pairs: [
            { left: "Mon-Fri", right: "Work (9am-5pm)" },
            { left: "Tuesday Evening", right: "Gym Class" },
            { left: "Sunday", right: "Visit Grandma" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Does Sarah work on Saturday?", options: ["No", "Yes"], a: "No" },
        { type: "mc", q: "When does she go to the gym?", options: ["Tuesday evening", "Monday morning", "Sunday"], a: "Tuesday evening" },
        { type: "input", q: "She visits her ___ (relative) on Sunday.", a: "Grandma" },
        { type: "order", q: "Ordena", words: ["She", "is", "busy", "on", "weekdays."], a: "She is busy on weekdays." },
        { type: "mc", q: "Logic: If today is Wednesday, is she working?", options: ["Yes", "No"], a: "Yes" },
        { type: "input", q: "She works ___ (5) days a week.", a: "five" },
        { type: "order", q: "Ordena", words: ["Her", "schedule", "is", "full."], a: "Her schedule is full." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: CONDITIONAL TRANSLATION (If she...)
    // Enfoque: Adaptar la frase al sujeto (I play -> She plays).
    // ----------------------------------------------------------------------
    {
      id: "u14-set7",
      title: "Set 7: Change the Subject",
      questions: [
        {
          type: "match",
          q: "Match I to She",
          pairs: [
            { left: "I work", right: "She works" },
            { left: "I go", right: "She goes" },
            { left: "I have", right: "She has" }
          ],
          a: "completed"
        },
        { type: "mc", q: "If I play tennis, how do you say 'Ella juega'?", options: ["She plays", "She play", "She playing"], a: "She plays" },
        { type: "input", q: "I watch TV. -> He ___ TV.", a: "watches" },
        { type: "order", q: "Transforma: I study English -> She...", words: ["She", "studies", "English."], a: "She studies English." },
        { type: "mc", q: "I go to the park. -> My brother ___ to the park.", options: ["goes", "go", "going"], a: "goes" },
        { type: "input", q: "We live here. -> Sarah ___ (vivir) here.", a: "lives" },
        { type: "order", q: "Transforma: They eat lunch -> He...", words: ["He", "eats", "lunch."], a: "He eats lunch." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: MIXED PRACTICE (Dialogue Prep)
    // Enfoque: Preparar preguntas y respuestas.
    // ----------------------------------------------------------------------
    {
      id: "u14-set8",
      title: "Set 8: Making Plans",
      questions: [
        { type: "order", q: "Pregunta", words: ["Are", "you", "free", "on", "Friday?"], a: "Are you free on Friday?" },
        { type: "mc", q: "No, I ___ on Friday.", options: ["work", "works", "working"], a: "work" },
        { type: "input", q: "How about ___ (sábado)?", a: "Saturday" },
        { type: "match",
          q: "Match Q&A",
          pairs: [
            { left: "Do you work?", right: "No, I don't." },
            { left: "When are you free?", right: "On Sunday." },
            { left: "Let's meet?", right: "Ok, great!" }
          ],
          a: "completed"
        },
        { type: "order", q: "Respuesta", words: ["Yes,", "I", "am", "free."], a: "Yes, I am free." },
        { type: "mc", q: "Let's go to the cinema.", options: ["Great idea!", "Yes I am", "On Monday"], a: "Great idea!" },
        { type: "input", q: "See you ___ (el) weekend!", a: "on" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: WRITING PRACTICE (Fill the blanks)
    // Enfoque: Completar un texto largo.
    // ----------------------------------------------------------------------
    {
      id: "u14-set9",
      title: "Set 9: My Routine",
      questions: [
        { type: "blank", q: "Hi! My name is Alex. I ___ (ser) a student.", a: "am" },
        { type: "blank", q: "I ___ (ir) to university from Monday to Friday.", a: "go" },
        { type: "mc", q: "I study ___ the mornings.", options: ["in", "on", "at"], a: "in" },
        { type: "input", q: "On Fridays, I ___ (jugar) basketball.", a: "play" },
        { type: "mc", q: "I love the ___ (Sat & Sun).", options: ["weekend", "weekdays"], a: "weekend" },
        { type: "order", q: "Ordena", words: ["I", "relax", "with", "my", "friends."], a: "I relax with my friends." },
        { type: "match",
          q: "Alex's Summary",
          pairs: [
            { left: "Job", right: "Student" },
            { left: "Sport", right: "Basketball" },
            { left: "Relax", right: "Weekend" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: ULTIMATE CHALLENGE (Translation & Logic)
    // Enfoque: Demostrar dominio total.
    // ----------------------------------------------------------------------
    {
      id: "u14-set10",
      title: "Set 10: Master Translator",
      questions: [
        { type: "order", q: "Traduce: 'Mi hermano va a la escuela de lunes a viernes.'", words: ["My", "brother", "goes", "to", "school", "from", "Monday", "to", "Friday."], a: "My brother goes to school from Monday to Friday." },
        { type: "input", q: "Traduce: 'Yo trabajo en las mañanas.' -> I work ___ the mornings.", a: "in" },
        { type: "match",
          q: "Correct the errors",
          pairs: [
            { left: "I works", right: "I work" },
            { left: "On the morning", right: "In the morning" },
            { left: "In Monday", right: "On Monday" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Traduce: 'Ella nunca cocina.'", options: ["She never cooks.", "She never cook.", "She cooks never."], a: "She never cooks." },
        { type: "order", q: "Traduce: 'Nosotros jugamos tenis los fines de semana.'", words: ["We", "play", "tennis", "on", "weekends."], a: "We play tennis on weekends." },
        { type: "input", q: "Traduce: '¿Vas al gimnasio?' -> Do you ___ to the gym?", a: "go" },
        { type: "order", q: "Final", words: ["I", "have", "a", "busy", "week!"], a: "I have a busy week!" }
      ]
    }
  ]
};